export default {
	template: {
		header: 8
	},
	fileType: ".xlsx,.xlsb,.xlsm,.xls",
	DocUploadType: ".doc,.docx,.xlx,.xlsx,.xlsm,.ppt,.pptx,.pdf,.zip,.txt"
}